import React from 'react';
export function TermsAndConditionsPage() {
  return <div className="min-h-screen bg-white text-slate-900 font-sans" data-id="element-508">
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16" data-id="element-509">
        <article className="prose prose-slate max-w-none" data-id="element-510">
          {/* Header */}
          <header className="mb-12 border-b border-slate-200 pb-8" data-id="element-511">
            <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mb-4" data-id="element-512">
              Términos y Condiciones de Uso
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-513">
              APP y tarjeta LevelUp Play
            </p>
          </header>

          {/* Section 1 */}
          <section className="mb-12" data-id="element-514">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-515">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-516">
                1
              </span>
              NATURALEZA DEL PROGRAMA
            </h2>
            <div className="pl-4 sm:pl-6 border-l-2 border-slate-100" data-id="element-517">
              <p className="text-slate-600 leading-relaxed" data-id="element-518">
                El presente documento establece los términos y condiciones
                aplicables al uso de la tarjeta de fidelización gratuita
                denominada LevelUp Play (en adelante, "la Tarjeta"), la cual
                permite a sus titulares acceder a beneficios, descuentos y
                promociones ofrecidos por comercios afiliados al programa.
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section className="mb-12" data-id="element-519">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-520">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-521">
                2
              </span>
              ACCESO A LA TARJETA
            </h2>
            <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-slate-100" data-id="element-522">
              <p className="text-slate-600 leading-relaxed" data-id="element-523">
                La Tarjeta es gratuita y de uso personal e intransferible.
              </p>
              <p className="text-slate-600 leading-relaxed" data-id="element-524">
                Podrá acceder a ella cualquier persona natural mayor de edad que
                complete el formulario de afiliación correspondiente.
              </p>
              <p className="text-slate-600 leading-relaxed" data-id="element-525">
                El uso de la Tarjeta implica la aceptación plena de estos
                términos y condiciones.
              </p>
            </div>
          </section>

          {/* Section 3 */}
          <section className="mb-12" data-id="element-526">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-527">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-528">
                3
              </span>
              BENEFICIOS Y PROMOCIONES
            </h2>
            <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-slate-100" data-id="element-529">
              <p className="text-slate-600 leading-relaxed" data-id="element-530">
                Los beneficios ofrecidos pueden incluir: descuentos directos,
                promociones especiales, servicios preferenciales, obsequios u
                otros incentivos, según lo determine cada comercio afiliado.
              </p>
              <p className="text-slate-600 leading-relaxed" data-id="element-531">
                Cada comercio es el único responsable de aplicar, mantener,
                modificar o cancelar los beneficios que ofrece a los usuarios de
                la Tarjeta.
              </p>
              <p className="text-slate-600 leading-relaxed" data-id="element-532">
                Los beneficios están sujetos a condiciones particulares propias
                de cada comercio (vigencia, stock, montos mínimos de compra,
                restricciones, etc.).
              </p>
            </div>
          </section>

          {/* Section 4 */}
          <section className="mb-12" data-id="element-533">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-534">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-535">
                4
              </span>
              RESPONSABILIDAD DEL PROGRAMA
            </h2>
            <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-slate-100" data-id="element-536">
              <p className="text-slate-600 leading-relaxed" data-id="element-537">
                TicketMaestro y su plataforma Benefika, empresa procesadora de
                La Tarjeta, actúa únicamente como intermediario que conecta a
                los usuarios con comercios aliados, sin asumir responsabilidad
                por la calidad, disponibilidad o condiciones de los productos o
                servicios ofrecidos.
              </p>
              <p className="text-slate-600 leading-relaxed" data-id="element-538">
                En caso de cualquier inconveniente o reclamo relacionado con los
                beneficios, el usuario deberá comunicarse directamente con el
                comercio correspondiente.
              </p>
            </div>
          </section>

          {/* Section 5 */}
          <section className="mb-12" data-id="element-539">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-540">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-541">
                5
              </span>
              VIGENCIA Y MODIFICACIONES
            </h2>
            <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-slate-100" data-id="element-542">
              <p className="text-slate-600 leading-relaxed" data-id="element-543">
                La vigencia de la Tarjeta es indefinida, salvo que el usuario o
                la organización emiten renuncien expresamente a su uso.
              </p>
              <p className="text-slate-600 leading-relaxed" data-id="element-544">
                La organización se reserva el derecho de modificar, suspender o
                cancelar el programa o sus términos y condiciones, informando
                oportunamente a los usuarios a través de sus canales oficiales.
              </p>
            </div>
          </section>

          {/* Section 6 */}
          <section className="mb-12" data-id="element-545">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-546">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-547">
                6
              </span>
              PROTECCIÓN DE DATOS PERSONALES
            </h2>
            <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-slate-100" data-id="element-548">
              <p className="text-slate-600 leading-relaxed" data-id="element-549">
                Al afiliarse, el usuario autoriza el tratamiento de sus datos
                personales conforme a la legislación vigente, exclusivamente
                para fines informativos y promocionales relacionados con el
                programa.
              </p>
              <p className="text-slate-600 leading-relaxed" data-id="element-550">
                Los datos no serán compartidos con terceros sin consentimiento
                del titular, salvo requerimiento legal. Puede ver más detalles
                en el documento de nuestras Políticas de Privacidad y Protección
                de Datos Personales.
              </p>
            </div>
          </section>

          {/* Section 7 */}
          <section className="mb-12" data-id="element-551">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-552">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-553">
                7
              </span>
              USO INDEBIDO Y CANCELACIÓN
            </h2>
            <div className="space-y-4 pl-4 sm:pl-6 border-l-2 border-slate-100" data-id="element-554">
              <p className="text-slate-600 leading-relaxed" data-id="element-555">
                El uso fraudulento, indebido o contrario a estos términos puede
                dar lugar a la anulación inmediata de la Tarjeta y la pérdida de
                sus beneficios.
              </p>
              <p className="text-slate-600 leading-relaxed" data-id="element-556">
                La organización podrá retirar o suspender la tarjeta en caso de
                mal uso sin necesidad de notificación previa.
              </p>
            </div>
          </section>

          {/* Section 8 */}
          <section className="mb-12" data-id="element-557">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-558">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-559">
                8
              </span>
              VIGENCIA
            </h2>
            <div className="pl-4 sm:pl-6 border-l-2 border-slate-100" data-id="element-560">
              <p className="text-slate-600 leading-relaxed" data-id="element-561">
                La vigencia de estos Términos y Condiciones de Uso es desde el
                12 de septiembre de 2025 y permanecerá vigente hasta que exista
                una nueva versión que la reemplace.
              </p>
            </div>
          </section>

          {/* Footer Note */}
          <footer className="mt-16 pt-8 border-t border-slate-200 text-center" data-id="element-562">
            <p className="text-slate-500 text-sm" data-id="element-563">
              Asociación Ecuatoriana de Deportes Electrónicos
            </p>
          </footer>
        </article>
      </main>
    </div>;
}